import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTimeWithSeconds } from '../../helpers/date.helper';
import JsonModal from '../modals/JsonModal';
import Select from '../forms/Select';

import { RevisionModel, RevisionType } from '../../api/api.types';
import ListViewTable from './ListViewTable';


interface AuditLogProps {
  revisions: RevisionModel[];
  jsonFieldNames?: string[];
  showId?: boolean;
}

const AuditLog: React.FC<AuditLogProps> =
  (props) => {
    const [ filteredRevisions, setFilteredRevisions ] = useState<RevisionModel[]>([]);
    const [ modalOpen, setModalOpen ] = useState(false);
    const [ modalTitle, setModalTitle ] = useState<string>('');
    const [ modalData, setModalData ] = useState<string>('');
    const [ filterValue, setFilterValue ] = useState<{ label: string; value: string }>({
      label: 'MODIFIED',
      value: RevisionType.MOD
    });
    const { t } = useTranslation();

    useEffect(() => {
      getFilteredData(props.revisions, RevisionType.MOD);

    }, [ props.revisions, t ]);

    const revisionTypeCell = (cellProps: any) => {
      if (cellProps === RevisionType.ADD) {
        return 'CREATED';
      } else {
        return 'MODIFIED';
      }
    };

    const getFilteredData = (data: RevisionModel[], revisionType?: string) => {
      if (revisionType === 'ALL') {
        setFilteredRevisions(data);
      } else {
        setFilteredRevisions(data.filter((revision) => revision.revisionType === revisionType));
      }
    };

    const modifiedAtCell = ({ cell }: { cell: any }) => {
      return (
        <div className="numeric-content">
          {`${formatDateTimeWithSeconds(cell.row.original.modifiedAt)}`}
        </div>
      );
    };

    const newValueCell = ({ cell }: { cell: any }) => {
      if (props.jsonFieldNames && props.jsonFieldNames.findIndex((fieldName) => cell.row.original.fieldName === fieldName) !== -1) {
        const value = JSON.parse(cell.row.original.fieldValue);
        return (

          <button type="button" className="btn btn-link font-normal p-0" onClick={() => {
            setModalOpen(true);
            setModalData(value);
            setModalTitle(cell.row.original.fieldName);
          }}>
            View value
          </button>
        );
      }
      return cell.row.original.fieldValue;
    };

    function defineColumns() {
      const columns = [
        {
          header: t('ct.reservation_audit_log.revision_number'),
          accessorKey: 'revisionNumber',
          id: 'revisionNumber'
        },
        {
          header: t('ct.reservation_audit_log.revision_type'),
          accessorKey: 'revisionType',
          id: 'revisionType',
          cell: (cell: any) => revisionTypeCell(cell.getValue())
        },
        {
          header: t('ct.reservation_audit_log.modified_by'),
          accessorKey: 'modifiedBy',
          id: 'modifiedBy'
        },
        {
          header: t('ct.reservation_audit_log.modified_at'),
          accessorKey: 'modifiedAt',
          id: 'modifiedAt',
          cell: ({ cell }: { cell: any }) => modifiedAtCell({ cell })
        },
        {
          header: t('ct.reservation_audit_log.field_name'),
          accessorKey: 'fieldName',
          id: 'fieldName'
        },
        {
          header: t('ct.reservation_audit_log.new_value'),
          accessorKey: 'fieldValue',
          id: 'fieldValue',
          cell: ({ cell }: { cell: any }) => newValueCell({ cell }),
          width: 400
        }
      ];

      if (props.showId) {
        columns.splice(1, 0, {
          header: 'Id',
          accessorKey: 'id',
          id: 'id'
        });
      }

      return columns;
    }

    function updateFilterValue(val: any) {
      setFilterValue(val);
      getFilteredData(props.revisions, val.value);
    }

    return (
      <>
        <form
          className="d-flex justify-content-between container-fluid filter-container form-group form-inline">
          <div className="d-flex flex-wrap filters-container">
            <Select
              value={filterValue}
              className="mr-1"
              elWidth={240}
              placeholder={t('ph.filter.one_way_fees.by_return_desk')}
              options={[
                { label: 'MODIFIED', value: RevisionType.MOD },
                { label: 'CREATED', value: RevisionType.ADD },
                { label: 'ALL', value: 'ALL' }
              ]}
              onChange={(val) => updateFilterValue(val)}
              equalWidthElement
              marginTop
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              disableClear
              label="revisionType"
            />
          </div>
        </form>
        <ListViewTable data={filteredRevisions} columns={defineColumns()}/>
        <JsonModal
          content={modalData}
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          toggle={() => setModalOpen(false)}
          title={modalTitle}
        />
      </>
    );
  };
export default AuditLog;
